const LABELS = { email_off: "not sent (email off)" };

export const StatusBadge = ({ status, testId }) => (
  <span className={`hx-badge hx-badge--${status}`} data-testid={testId}>{LABELS[status] || status}</span>
);
